import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: 'How do I receive the pack after purchasing?',
  a: 'You will receive immediate access to all the material so you can start using it right away — no waiting, no complicated steps.'
}, {
  q: 'What level of yoga teacher is this for?',
  a: 'Yoga Teacher Ready™ is designed for yoga teachers at any stage of their career — whether you are newly certified or have been teaching for years. If you want to spend less time planning and more time teaching, this library was built for you.'
}, {
  q: 'Does this work for yoga teachers in any country?',
  a: 'Yes. The material is written in professional English and is designed to be used in any teaching environment, anywhere in the world.'
}, {
  q: 'Can I edit the material?',
  a: 'The material is delivered in ready-to-use PDF format. You can print it, reference it on any device, and use it directly in your sessions.'
}, {
  q: 'What currency will I pay in?',
  a: 'The price adapts automatically to your local currency based on the country you are purchasing from.'
}, {
  q: 'What if I do not find it useful?',
  a: 'You are covered by a complete 7-day money-back guarantee. If the material does not meet your needs, contact us and we will refund every cent — no questions asked.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-dark-card" data-id="element-81" data-mp="16oqsw71pyx4o">
      <div className="max-w-3xl mx-auto" data-id="element-82" data-mp="rz2upeou4el6">
        <div className="text-center mb-16" data-id="element-83" data-mp="s0dvr6qwb88l">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-84" data-mp="rx86nri9o6cv">
            ❓ Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-4" data-id="element-85" data-mp="iy4mslb9zmxb">
          {faqs.map((faq, index) => <div key={index} className="bg-black border border-dark-border rounded-xl overflow-hidden" data-id="element-86" data-mp="mzq54m6kwtew" data-mpi={index}>
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-87" data-mp="2po7xthr8p6vw">
                <span className="font-bold text-lg text-white pr-8" data-id="element-88" data-mp="2fuhcumubneky">
                  {faq.q}
                </span>
                <ChevronDown className={`text-gold transition-transform duration-300 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-89" data-mp="38lhljb3ll6iy" />
              </button>

              <AnimatePresence data-id="element-90" data-mp="2ynbl6xxfw8g7">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-91" data-mp="2ypehfzp6qxtd">
                    <div className="px-6 pb-5 text-gray-300 border-t border-dark-border/50 pt-4" data-id="element-92" data-mp="2nrfg9xira8z">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}